import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

export const CREATE_TEMPLATE_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.CreateBlueprintsVersionedGroup,
];

/**
 * Hook that returns whether current user can create template
 * User needs to be an admin or have SpaceAdmin or CreateBlueprintsVersionedGroup action in at least one space
 * @returns {AccessResult} Object indicating if user can create template and a message if not
 */
const useCanCreateTemplate = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(CREATE_TEMPLATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateTemplate;
